// ═══ 신뢰속도 (Trust Speed) 5단계 등급 — 클라이언트 미러 (Wave TS-1.e) ═══
// 2026-06-03
//
// 서버 정본: utils/trustSpeed.js + utils/migrations/2026-05-24-trust-speed-v1.js
//   (trust_speed_grades seed). CRA src/ 밖 import 제약 우회를 위한 사본
//   (utils/carColors.js 클라 미러 패턴 동일).
//
// 당근마켓 매너온도(°C) 대체 — 속도(km/h) 메타포. i18n 라벨 키는 speedGrade*.

var GRADES = {
  IDLE:      { emoji: '🐢', color: '#94a3b8', i18nKey: 'speedGradeIdle',      labelKo: '저속' },
  CRUISE:    { emoji: '🚶', color: '#64748b', i18nKey: 'speedGradeCruise',    labelKo: '순항' },
  RAPID:     { emoji: '🚗', color: '#2563eb', i18nKey: 'speedGradeRapid',     labelKo: '쾌속' },
  BLAZE:     { emoji: '🏎️', color: '#dc2626', i18nKey: 'speedGradeBlaze',     labelKo: '고속' },
  LIGHTNING: { emoji: '⚡', color: '#f59e0b', i18nKey: 'speedGradeLightning', labelKo: '초고속' },
};

var GRADE_ORDER = ['IDLE', 'CRUISE', 'RAPID', 'BLAZE', 'LIGHTNING'];

function getGrade(grade) {
  return GRADES[grade] || GRADES.IDLE;
}

function gradeEmoji(grade) { return getGrade(grade).emoji; }
function gradeColor(grade) { return getGrade(grade).color; }
function gradeI18nKey(grade) { return getGrade(grade).i18nKey; }
function gradeLabelKo(grade) { return getGrade(grade).labelKo; }

export { GRADES, GRADE_ORDER, getGrade, gradeEmoji, gradeColor, gradeI18nKey, gradeLabelKo };
